export class Password {
    password:string;
    newPassword:string;
    confirmPassword:string;

    constructor(password:any) {
        this.password = password.password;
        this.newPassword = password.newPassword;
        this.confirmPassword = password.confirmPassword;
    }
}